document.addEventListener('DOMContentLoaded', function () {

  const DESKTOP_BREAKPOINT = 768;

  document.querySelectorAll('media-gallery').forEach(function (gallery) {

    let resizeTimer = null;
    let syncTimers = [];
    let isSyncing = false;
    let wasDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;


    /* ==================================================
       BASIC HELPERS
    ================================================== */

    function isDesktop() {
      return window.innerWidth >= DESKTOP_BREAKPOINT;
    }


    function getMainSlider() {
      return gallery.querySelector(
        '.main-image .slider'
      );
    }


    function getThumbnailViewport() {
      return gallery.querySelector(
        '.thumbnails > .slider'
      );
    }


    function getThumbnailTrack() {
      return gallery.querySelector(
        '.thumbnails .thumbnail_slider'
      );
    }


    function getThumbnailItems() {

      const track =
        getThumbnailTrack();

      if (!track) {
        return [];
      }

      return Array.from(
        track.querySelectorAll(
          ':scope > .slider__item'
        )
      );
    }


    /* ==================================================
       GALLERY READY
    ================================================== */

    function galleryReady() {

      return (
        getMainSlider() &&
        getThumbnailViewport() &&
        getThumbnailTrack()
      );
    }


    /* ==================================================
       MAIN IMAGE HEIGHT
    ================================================== */

    function getMainImageHeight() {

      const mainSlider =
        getMainSlider();

      if (!mainSlider) {
        return 0;
      }


      const sliderRect =
        mainSlider.getBoundingClientRect();

      if (
        sliderRect.height &&
        sliderRect.height > 0
      ) {
        return sliderRect.height;
      }


      const mainImage =
        gallery.querySelector(
          '.main-image'
        );

      if (mainImage) {

        const rect =
          mainImage.getBoundingClientRect();

        if (
          rect.height &&
          rect.height > 0
        ) {
          return rect.height;
        }
      }

      return 0;
    }


    /* ==================================================
       RESET DESKTOP STYLES
    ================================================== */

    function resetDesktopStyles() {

      const viewport =
        getThumbnailViewport();

      const track =
        getThumbnailTrack();

      if (!viewport || !track) {
        return;
      }


      /* VIEWPORT */

      viewport.style.removeProperty(
        'height'
      );

      viewport.style.removeProperty(
        'max-height'
      );

      viewport.style.removeProperty(
        'overflow'
      );

      viewport.style.removeProperty(
        'overflow-y'
      );

      viewport.style.removeProperty(
        'overflow-x'
      );

      viewport.style.removeProperty(
        'scroll-behavior'
      );

      viewport.style.removeProperty(
        'scrollbar-width'
      );

      viewport.style.removeProperty(
        'overscroll-behavior'
      );


      /* TRACK */

      track.style.removeProperty(
        'display'
      );

      track.style.removeProperty(
        'flex-direction'
      );

      track.style.removeProperty(
        'width'
      );

      track.style.removeProperty(
        'height'
      );

      track.style.removeProperty(
        'padding'
      );

      track.style.removeProperty(
        'padding-bottom'
      );

      track.style.removeProperty(
        'margin'
      );

      track.style.removeProperty(
        'transform'
      );

      track.style.removeProperty(
        'transition'
      );


      /* THUMBNAILS */

      getThumbnailItems().forEach(
        function (item) {

          item.style.removeProperty(
            'flex'
          );

          item.style.removeProperty(
            'width'
          );

          item.style.removeProperty(
            'height'
          );

          item.style.removeProperty(
            'min-height'
          );

          item.style.removeProperty(
            'max-height'
          );

          item.style.removeProperty(
            'aspect-ratio'
          );

        }
      );
    }


    /* ==================================================
       ACTIVE MAIN SLIDE
    ================================================== */

    function getActiveMainSlide() {

      const mainSlider =
        getMainSlider();

      if (!mainSlider) {
        return null;
      }

      return mainSlider.querySelector(
        '.slider__item.is-active'
      );
    }


    /* ==================================================
       ACTIVE MEDIA ID
    ================================================== */

    function getActiveMediaId() {

      const activeSlide =
        getActiveMainSlide();

      if (!activeSlide) {
        return null;
      }

      return activeSlide.getAttribute(
        'data-media-id'
      );
    }


    /* ==================================================
       MATCHING THUMBNAIL
    ================================================== */

    function getMatchingThumbnail() {

      const mediaId =
        getActiveMediaId();

      if (!mediaId) {
        return null;
      }

      const thumbnails =
        getThumbnailItems();

      return thumbnails.find(
        function (thumbnail) {

          return (
            thumbnail.getAttribute(
              'data-media-id'
            ) === mediaId
          );

        }
      ) || null;
    }


    /* ==================================================
       DESKTOP SETUP
    ================================================== */

    function setupDesktop() {

      if (!isDesktop()) {
        return;
      }

      if (!galleryReady()) {
        return;
      }

      const viewport =
        getThumbnailViewport();

      const track =
        getThumbnailTrack();

      const thumbnails =
        getThumbnailItems();

      if (
        !viewport ||
        !track ||
        !thumbnails.length
      ) {
        return;
      }


      const mainHeight =
        getMainImageHeight();

      if (
        !mainHeight ||
        mainHeight <= 0
      ) {
        return;
      }


      /*
       * Thumbnail viewport has exactly the same
       * height as the main image.
       */

      viewport.style.height =
        `${Math.round(mainHeight)}px`;

      viewport.style.maxHeight =
        `${Math.round(mainHeight)}px`;


      /*
       * Native scrolling.
       */

      viewport.style.overflowY =
        'auto';

      viewport.style.overflowX =
        'hidden';

      viewport.style.scrollBehavior =
        'smooth';

      viewport.style.scrollbarWidth =
        'none';

      viewport.style.overscrollBehavior =
        'contain';


      /*
       * Vertical thumbnail track.
       */

      track.style.display =
        'flex';

      track.style.flexDirection =
        'column';

      track.style.width =
        '100%';

      track.style.height =
        'max-content';

      track.style.paddingBottom =
        '0';

      track.style.margin =
        '0';


      /*
       * Never use transform because native
       * scrolling must remain available.
       */

      track.style.removeProperty(
        'transform'
      );

      track.style.removeProperty(
        'transition'
      );


      /*
       * Thumbnail items.
       */

      thumbnails.forEach(
        function (item) {

          item.style.flex =
            '0 0 auto';

          item.style.width =
            '100%';

          item.style.height =
            'auto';

          item.style.minHeight =
            '0';

          item.style.maxHeight =
            'none';

        }
      );
    }


    /* ==================================================
       NORMAL TARGET POSITION
    ================================================== */

    function calculateTargetPosition(
      thumbnail
    ) {

      const viewport =
        getThumbnailViewport();

      if (
        !viewport ||
        !thumbnail
      ) {
        return 0;
      }


      const viewportRect =
        viewport.getBoundingClientRect();

      const thumbnailRect =
        thumbnail.getBoundingClientRect();


      const currentScroll =
        viewport.scrollTop;


      const maxScroll =
        Math.max(
          0,
          viewport.scrollHeight -
          viewport.clientHeight
        );


      /*
       * Already fully visible.
       * Preserve user's manual scroll.
       */

      if (
        thumbnailRect.top >=
          viewportRect.top &&
        thumbnailRect.bottom <=
          viewportRect.bottom
      ) {

        return currentScroll;
      }


      /*
       * Above viewport.
       */

      if (
        thumbnailRect.top <
        viewportRect.top
      ) {

        const target =
          currentScroll +
          (
            thumbnailRect.top -
            viewportRect.top
          );

        return Math.max(
          0,
          Math.min(
            target,
            maxScroll
          )
        );
      }


      /*
       * Below viewport.
       *
       * Put thumbnail top at viewport top.
       */

      if (
        thumbnailRect.bottom >
        viewportRect.bottom
      ) {

        const target =
          currentScroll +
          (
            thumbnailRect.top -
            viewportRect.top
          );

        return Math.max(
          0,
          Math.min(
            target,
            maxScroll
          )
        );
      }


      return currentScroll;
    }


    /* ==================================================
       MOVE THUMBNAIL VIEWPORT
    ================================================== */

    function moveThumbnailViewport(
      target,
      instant
    ) {

      const viewport =
        getThumbnailViewport();

      if (!viewport) {
        return;
      }


      viewport.scrollTo({
        top: target,
        behavior: instant
          ? 'auto'
          : 'smooth'
      });
    }


    /* ==================================================
       NORMAL ACTIVE THUMBNAIL SYNC
    ================================================== */

    function syncActiveThumbnail(
      instant = false
    ) {

      if (!isDesktop()) {
        return;
      }

      if (!galleryReady()) {
        return;
      }

      if (isSyncing) {
        return;
      }

      isSyncing = true;


      try {

        const track =
          getThumbnailTrack();

        const thumbnail =
          getMatchingThumbnail();

        if (
          !track ||
          !thumbnail
        ) {
          return;
        }


        /*
         * Active class.
         */

        track
          .querySelectorAll(
            '.slider__item.is-active'
          )
          .forEach(
            function (item) {

              if (
                item !== thumbnail
              ) {

                item.classList.remove(
                  'is-active'
                );

              }

            }
          );


        thumbnail.classList.add(
          'is-active'
        );


        /*
         * Normal position.
         */

        const target =
          calculateTargetPosition(
            thumbnail
          );


        moveThumbnailViewport(
          target,
          instant
        );

      } finally {

        isSyncing = false;

      }
    }


    /* ==================================================
       NORMAL DELAYED SYNC
    ================================================== */

    function delayedSync() {

      syncTimers.forEach(
        function (timer) {

          clearTimeout(timer);

        }
      );

      syncTimers = [];


      [50, 150, 300, 600].forEach(
        function (delay) {

          const timer =
            setTimeout(
              function () {

                if (!isDesktop()) {
                  return;
                }

                setupDesktop();

                syncActiveThumbnail(
                  false
                );

              },
              delay
            );


          syncTimers.push(
            timer
          );

        }
      );
    }


    /* ==================================================
       VARIANT CHANGE SYNC
    ================================================== */

    function delayedVariantSync() {

      syncTimers.forEach(
        function (timer) {
          clearTimeout(timer);
        }
      );

      syncTimers = [];


      /*
       * Shopify variant/media updates can happen
       * asynchronously.
       */

      const delays = [
        100,
        250,
        450,
        700,
        1000,
        1400
      ];


      delays.forEach(
        function (delay) {

          const timer =
            setTimeout(
              function () {

                if (!isDesktop()) {
                  return;
                }


                requestAnimationFrame(
                  function () {

                    requestAnimationFrame(
                      function () {

                        if (!isDesktop()) {
                          return;
                        }


                        setupDesktop();


                        const viewport =
                          getThumbnailViewport();

                        const thumbnail =
                          getMatchingThumbnail();


                        if (
                          !viewport ||
                          !thumbnail
                        ) {
                          return;
                        }


                        /*
                         * Force layout calculation.
                         */

                        void viewport.offsetHeight;
                        void thumbnail.offsetHeight;


                        const viewportRect =
                          viewport.getBoundingClientRect();

                        const thumbnailRect =
                          thumbnail.getBoundingClientRect();


                        /*
                         * Current scroll position.
                         */

                        const currentScroll =
                          viewport.scrollTop;


                        /*
                         * Calculate where the active
                         * thumbnail would be if its TOP
                         * were aligned with the viewport TOP.
                         */

                        const thumbnailOffset =
                          thumbnailRect.top -
                          viewportRect.top;


                        let target =
                          currentScroll +
                          thumbnailOffset;


                        /*
                         * Actual maximum possible
                         * native scroll.
                         */

                        const maxScroll =
                          Math.max(
                            0,
                            viewport.scrollHeight -
                            viewport.clientHeight
                          );


                        /*
                         * Never exceed actual bottom.
                         */

                        target =
                          Math.max(
                            0,
                            Math.min(
                              target,
                              maxScroll
                            )
                          );


                        /*
                         * If we're effectively at the
                         * end, force exact maxScroll.
                         */

                        const distanceFromBottom =
                          maxScroll -
                          target;


                        if (
                          distanceFromBottom <= 5
                        ) {

                          target =
                            maxScroll;

                        }


                        /*
                         * Final variant scroll.
                         */

                        viewport.scrollTo({
                          top: target,
                          behavior: 'smooth'
                        });

                      }
                    );

                  }
                );

              },
              delay
            );


          syncTimers.push(
            timer
          );

        }
      );
    }


    /* ==================================================
       MAIN SLIDER OBSERVER
    ================================================== */

    const mainSliderObserver =
      new MutationObserver(
        function (mutations) {

          if (!isDesktop()) {
            return;
          }


          let changed = false;


          mutations.forEach(
            function (mutation) {

              if (
                mutation.type ===
                'attributes'
              ) {

                if (
                  mutation.attributeName ===
                    'class' ||
                  mutation.attributeName ===
                    'data-media-id'
                ) {

                  changed = true;

                }

              }

            }
          );


          if (changed) {

            delayedSync();

          }

        }
      );


    function startMainObserver() {

      const mainSlider =
        getMainSlider();

      if (!mainSlider) {
        return;
      }


      mainSliderObserver.disconnect();


      mainSliderObserver.observe(
        mainSlider,
        {
          subtree: true,
          attributes: true,
          attributeFilter: [
            'class',
            'data-media-id'
          ]
        }
      );
    }


    /* ==================================================
       GALLERY DOM OBSERVER
    ================================================== */

    const galleryObserver =
      new MutationObserver(
        function (mutations) {

          let structureChanged =
            false;


          mutations.forEach(
            function (mutation) {

              if (
                mutation.type ===
                'childList'
              ) {

                structureChanged = true;

              }

            }
          );


          if (
            structureChanged &&
            isDesktop()
          ) {

            setTimeout(
              function () {

                if (
                  galleryReady()
                ) {

                  setupDesktop();

                  startMainObserver();

                  bindImageLoadEvents();

                }

              },
              50
            );

          }

        }
      );


    galleryObserver.observe(
      gallery,
      {
        childList: true,
        subtree: true
      }
    );


    /* ==================================================
       RESIZE OBSERVER
    ================================================== */

    let resizeObserver = null;


    if (
      typeof ResizeObserver !==
      'undefined'
    ) {

      resizeObserver =
        new ResizeObserver(
          function () {

            if (!isDesktop()) {
              return;
            }


            setupDesktop();

          }
        );


      const mainSlider =
        getMainSlider();

      if (mainSlider) {

        resizeObserver.observe(
          mainSlider
        );

      }


      const mainImage =
        gallery.querySelector(
          '.main-image'
        );

      if (mainImage) {

        resizeObserver.observe(
          mainImage
        );

      }

    }


    /* ==================================================
       THUMBNAIL CLICK
    ================================================== */

    gallery.addEventListener(
      'click',
      function (event) {

        if (!isDesktop()) {
          return;
        }


        const thumbnail =
          event.target.closest(
            '.thumbnails .slider__item'
          );


        if (!thumbnail) {
          return;
        }


        /*
         * Let Shopify/theme handle the actual
         * main image change.
         */

        delayedSync();

      }
    );


    /* ==================================================
       NEXT / PREVIOUS
    ================================================== */

    gallery.addEventListener(
      'click',
      function (event) {

        if (!isDesktop()) {
          return;
        }


        const nextButton =
          event.target.closest(
            '.main-image button[name="next"]'
          );


        const prevButton =
          event.target.closest(
            '.main-image button[name="prev"]'
          );


        if (
          !nextButton &&
          !prevButton
        ) {
          return;
        }


        delayedSync();

      }
    );


    /* ==================================================
       VARIANT / COLOR CHANGE
    ================================================== */

    gallery.addEventListener(
      'change',
      function (event) {

        if (!isDesktop()) {
          return;
        }


        const input =
          event.target.closest(
            'input[type="radio"]'
          );


        if (!input) {
          return;
        }


        /*
         * Variant changes use the special positioning
         * logic.
         */

        delayedVariantSync();

      }
    );


    /* ==================================================
       IMAGE LOAD EVENTS
    ================================================== */

    function bindImageLoadEvents() {

      const mainSlider =
        getMainSlider();

      const thumbnailTrack =
        getThumbnailTrack();


      /*
       * MAIN IMAGES
       */

      if (mainSlider) {

        mainSlider
          .querySelectorAll('img')
          .forEach(
            function (img) {

              if (
                img.dataset.pdpSyncBound ===
                'true'
              ) {
                return;
              }


              img.dataset.pdpSyncBound =
                'true';


              img.addEventListener(
                'load',
                function () {

                  if (!isDesktop()) {
                    return;
                  }


                  setupDesktop();


                  setTimeout(
                    function () {

                      syncActiveThumbnail(
                        true
                      );

                    },
                    50
                  );

                }
              );

            }
          );

      }


      /*
       * THUMBNAILS
       */

      if (thumbnailTrack) {

        thumbnailTrack
          .querySelectorAll('img')
          .forEach(
            function (img) {

              if (
                img.dataset.pdpSyncBound ===
                'true'
              ) {
                return;
              }


              img.dataset.pdpSyncBound =
                'true';


              img.addEventListener(
                'load',
                function () {

                  if (!isDesktop()) {
                    return;
                  }


                  setupDesktop();


                  syncActiveThumbnail(
                    true
                  );

                }
              );

            }
          );

      }

    }


    /* ==================================================
       RESPONSIVE HANDLING
    ================================================== */

    window.addEventListener(
      'resize',
      function () {

        clearTimeout(
          resizeTimer
        );


        resizeTimer =
          setTimeout(
            function () {

              const nowDesktop =
                isDesktop();


              /*
               * DESKTOP → MOBILE
               */

              if (
                wasDesktop &&
                !nowDesktop
              ) {

                resetDesktopStyles();


                wasDesktop =
                  nowDesktop;


                return;
              }


              /*
               * MOBILE → DESKTOP
               */

              if (
                !wasDesktop &&
                nowDesktop
              ) {

                setTimeout(
                  function () {

                    setupDesktop();

                    startMainObserver();

                    bindImageLoadEvents();

                    syncActiveThumbnail(
                      true
                    );

                  },
                  100
                );

              }


              /*
               * DESKTOP → DESKTOP
               */

              if (
                wasDesktop &&
                nowDesktop
              ) {

                setupDesktop();


                setTimeout(
                  function () {

                    syncActiveThumbnail(
                      true
                    );

                  },
                  100
                );

              }


              wasDesktop =
                nowDesktop;

            },
            150
          );

      }
    );


    /* ==================================================
       INITIAL SETUP
    ================================================== */

    function initialize() {

      if (!galleryReady()) {
        return;
      }


      startMainObserver();

      bindImageLoadEvents();


      if (!isDesktop()) {

        resetDesktopStyles();

        return;
      }


      /*
       * Wait for main image/layout.
       */

      [100, 300, 600].forEach(
        function (delay) {

          setTimeout(
            function () {

              if (!isDesktop()) {
                return;
              }


              setupDesktop();


              syncActiveThumbnail(
                true
              );

            },
            delay
          );

        }
      );

    }


    initialize();

  });

});